import React, { Component } from "react";
import { Card, Dimmer, Loader, Feed, Table } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as HomeAction from "./homePageActions";
import { GridPager } from "../../common";
import "rc-pagination/assets/index.css";
import LazyLoad from "react-lazyload";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageLimit: 10,
      visibilityOfPagination: true
    };
    this.onPageChange = this.onPageChange.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
  }

  componentDidMount() {
    const { pageLimit } = this.state;
    const { homeActions } = this.props;
    const params = {
      page: 1,
      start: 0,
      limit: pageLimit
    };
    homeActions.onGetBookmarks(params);
    homeActions.onGetTopTenLikedBookmarks();
    homeActions.onGetActiveBookmarkSites();
  }

  onHandleChange(event, data) {
    const { history } = this.props;
    const websiteTitle = data.items.header.replace(/ /g, "-");
    const id = data.items.Id;
    history.push(`post/${id}/${websiteTitle}`, {
      bookmarkId: id,
      categoryName: data.items.categoryName,
      website: data.items.websiteURL
    });

    window.open('https://invoicestacks.com/', '_blank', 'noopener,noreferrer');

  }
  
  renderBookmarks(bookmarkLists) {
    if (bookmarkLists && bookmarkLists.length > 0) {
      return bookmarkLists.map(bookmarks => {
        return (
          <Card.Group key={bookmarks.Id}>
            <Card
              key={bookmarks.Id}
              link
              fluid
              items={{
                Id: bookmarks.Id,
                header: bookmarks.StoryTitle,
                categoryName: bookmarks.CategoryName,
                websiteURL: bookmarks.URL
              }}
              onClick={this.onHandleChange}
              style={{ width: "99%" }}
            >
              <Card.Content>
                <Card.Header>{bookmarks.StoryTitle}</Card.Header>
                <Card.Meta>{bookmarks.URL}</Card.Meta>
                <Card.Description>{bookmarks.Description !== undefined && bookmarks.Description !==null ? bookmarks.Description: bookmarks.Descriptions !== undefined && bookmarks.Descriptions.length >=1 ? bookmarks.Descriptions[0].Description : '' }</Card.Description>
                
              </Card.Content>
              <Card.Content extra>
                <div style={{ width: "100%" }}>
                  <div style={{ float: "left" }}>{bookmarks.CategoryName}</div>
                  <div style={{ float: "right", display: "inline-flex" }}>
                    <div style={{ display: "flex" }}>
                      <i className="eye icon"></i> {bookmarks.Views}
                    </div>

                    <div style={{ paddingLeft: "15%", display: "flex" }}>
                      <i className="thumbs up outline icon"></i>
                      {bookmarks.likes}
                    </div>
                  </div>
                </div>
              </Card.Content>
            </Card>
          </Card.Group>
        );
      });
    }
  }

  renderActiveBookmarkSites(bookmarkLists) {
    if (bookmarkLists && bookmarkLists.length > 0) {
      return bookmarkLists.map(bookmarks => {
        return (
          <Table.Row key={bookmarks}>
            <Table.Cell>
              <a href={`https://${bookmarks}/`}>
                <font color="black" size="3">
                  {`https://${bookmarks}/`}
                </font>
              </a>
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }

  onPageChange(current, pageSize) {
    const { homeActions } = this.props;
    const { pageLimit } = this.state;
    let params = {
      page: current,
      start: pageSize,
      limit: pageLimit
    };
    homeActions.onGetBookmarks(params);
    this.setState({
      currentPage: current
    });
  }

  render() {
    const {
      bookmarkLists,
      totalBookmarks,
      isLoading,
      activeBookmarkSites
    } = this.props;
    const { pageLimit, visibilityOfPagination, currentPage } = this.state;
    return (
      <div style={{ width: "100%", display: "inline-block" }}>
        <div style={{ width: "100%", marginTop: "10px", float: "left" }}>
          <Dimmer.Dimmable dimmed={isLoading}>
            <div style={{ height: 20 }}>
              <Dimmer active={isLoading} inverted={true}>
                <Loader>Loading</Loader>
              </Dimmer>
            </div>

            <div style={{ width: "100%", display: "inline-flex" }}>
              <div
                style={{
                  width: "75%",
                  wordWrap: "break-word",
                  paddingBottom: "10px",
                  paddingRight: "2%"
                }}
              >
                {this.renderBookmarks(bookmarkLists)}
              </div>

              <div style={{ width: "25%", wordWrap: "break-word" }}>
                <Card fluid>
                  <Card.Content>
                    <Card.Header>More Bookmarks Websites</Card.Header>
                  </Card.Content>
                  <Card.Content extra>
                    <Feed>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            width: "100%",
                            marginTop: "10px",
                            textAlign: "center"
                          }}
                        >
                          {/* <div>
                            <font size="4" color="black">
                              Download android app to submit URL. It's free
                            </font>
                          </div> */}
                          {/* <div style={{ paddingTop: "5px" }}>
                            <font size="4" color="red">
                              Please note: Already register users can use their
                              same credentials in app
                            </font>
                          </div> */}
                          {/* <div>
                            <LazyLoad resize>
                              <a href="https://play.google.com/store/apps/details?id=com.socialbookmarker">
                                <img
                                src={process.env.PUBLIC_URL + '/playstore.png'}
                                  style={{
                                    width: "50%",
                                    height: "50%",
                                    paddingTop: "5%"
                                  }}
                                />
                              </a>
                              <a href="https://apps.apple.com/app/social-bookmarker/id1514832913">
                              <img
                                src={process.env.PUBLIC_URL + '/appstore.png'}
                                style={{
                                  width: "45%",
                                  height: "50%",
                                  paddingTop: "5%"
                                }}
                              />
                            </a>
                            </LazyLoad>
                          </div> */}
                        </div>
                        <Table
                          singleLine
                          stackable
                          fixed
                          color="green"
                          size="large"
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>Back-links</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {this.renderActiveBookmarkSites(
                              activeBookmarkSites
                            )}
                          </Table.Body>
                        </Table>
                      </div>
                    </Feed>
                  </Card.Content>
                </Card>
              </div>
            </div>

            {visibilityOfPagination ? (
              <GridPager
                onChange={this.onPageChange}
                current={currentPage}
                total={totalBookmarks}
                defaultPageSize={pageLimit}
                showLessItems={true}
                showTitle={false}
                showSizeChanger={true}
                pageSize={this.state.pageLimit}
              />
            ) : null}
          </Dimmer.Dimmable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ homePage }) => {
  const {
    isLoading,
    bookmarkLists,
    totalBookmarks,
    activeBookmarkSites
  } = homePage;
  return {
    isLoading,
    bookmarkLists,
    totalBookmarks,
    activeBookmarkSites
  };
};

const mapDispatchToProps = dispatch => {
  return {
    homeActions: bindActionCreators(HomeAction, dispatch)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HomePage));
